/**
 * Retrato ilustrado para o depoimento.
 *
 * Nao usamos foto de banco de imagem: praticamente toda licenca (Getty,
 * Shutterstock, Unsplash) proibe uso que sugira que a pessoa retratada
 * endossa um produto, e um rosto real ao lado de um depoimento e exatamente
 * isso. A ilustracao nao tem esse problema. Se um dia houver foto de um
 * cliente de verdade, com autorizacao, basta trocar por <img>.
 */
export function Retrato({ tamanho = 56 }: { tamanho?: number }) {
  return (
    <svg className="retrato" width={tamanho} height={tamanho}
      viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <defs>
        <clipPath id="retrato-corte"><circle cx="32" cy="32" r="32" /></clipPath>
      </defs>
      <g clipPath="url(#retrato-corte)">
        <circle cx="32" cy="32" r="32" fill="var(--acento-suave)" />
        {/* ombros */}
        <path d="M6 64c0-13.3 11.6-21 26-21s26 7.7 26 21H6Z" fill="var(--acento)" />
        <path d="M26 40h12v8a6 6 0 0 1-12 0v-8Z" fill="#E8B79A" />
        {/* rosto */}
        <circle cx="32" cy="28" r="13" fill="#F2C6A8" />
        {/* cabelo */}
        <path
          d="M32 12c8.3 0 14 5.4 14 13.5 0 3-.6 5.4-1.6 7.6-.5-4.9-1.6-7.6-3.6-9.4-3 2.2-7 3.2-11.8 3.2-3 0-5.3-.5-7-1.4-.9 1.7-1.4 4.2-1.6 7.6-1.2-2.2-1.9-4.6-1.9-7.6C18.5 17.4 23.7 12 32 12Z"
          fill="#3A2B24"
        />
        <circle cx="27" cy="28" r="1.5" fill="#3A2B24" />
        <circle cx="37" cy="28" r="1.5" fill="#3A2B24" />
        <path d="M29 34c1.8 1.4 4.2 1.4 6 0" stroke="#3A2B24" strokeWidth="1.4"
          strokeLinecap="round" />
      </g>
    </svg>
  );
}

/**
 * Estrelas com meia estrela de verdade: a nota vira largura de um retangulo
 * que corta o preenchimento, entao 4,5 mostra metade e nao arredonda.
 */
export function Estrelas({ nota, tamanho = 18 }: { nota: number; tamanho?: number }) {
  const largura = Math.max(0, Math.min(5, nota)) / 5;
  const forma =
    "M9 1.4l2.3 4.7 5.2.7-3.8 3.6.9 5.2L9 13.2l-4.6 2.4.9-5.2L1.5 6.8l5.2-.7L9 1.4Z";
  return (
    <span className="estrelas" role="img"
      aria-label={`${nota.toFixed(1).replace(".", ",")} de 5`}>
      <svg width={tamanho * 5} height={tamanho} viewBox="0 0 90 18" fill="none">
        <defs>
          <clipPath id="estrelas-corte">
            <rect x="0" y="0" width={90 * largura} height="18" />
          </clipPath>
        </defs>
        {[0, 1, 2, 3, 4].map((i) => (
          <path key={i} d={forma} transform={`translate(${i * 18} 0)`}
            fill="none" stroke="var(--estrela)" strokeWidth="1.4"
            strokeLinejoin="round" />
        ))}
        <g clipPath="url(#estrelas-corte)">
          {[0, 1, 2, 3, 4].map((i) => (
            <path key={i} d={forma} transform={`translate(${i * 18} 0)`}
              fill="var(--estrela)" stroke="var(--estrela)" strokeWidth="1.4"
              strokeLinejoin="round" />
          ))}
        </g>
      </svg>
    </span>
  );
}
